import { Breakpoints } from '@angular/cdk/layout';

/**
 * Per-device preferences in localStorage, kept per user and per phone or desktop, and kept when
 * the user signs out (sign-out clears everything else). Keys: `pref.<name>.<userId>.<formFactor>`.
 */

export type FormFactor = 'mobile' | 'desktop';

const PREFIX = 'pref.';

/** A phone, held either way; tablets and desktops count as desktop. */
export function currentFormFactor(): FormFactor {
  try {
    return window.matchMedia(Breakpoints.Handset).matches ? 'mobile' : 'desktop';
  } catch {
    return 'desktop';
  }
}

export function preferenceKey(name: string, userId: string | null | undefined, formFactor: FormFactor): string {
  return `${PREFIX}${name}.${userId || 'anonymous'}.${formFactor}`;
}

export function readPreference(storage: Storage, name: string, userId: string | null | undefined, formFactor: FormFactor): string | null {
  try {
    return storage.getItem(preferenceKey(name, userId, formFactor));
  } catch {
    return null;
  }
}

export function writePreference(storage: Storage, name: string, userId: string | null | undefined, formFactor: FormFactor, value: string): void {
  try {
    storage.setItem(preferenceKey(name, userId, formFactor), value);
  } catch {
    // Private mode or blocked storage: the choice lasts until the page closes.
  }
}

/** Sign-out: removes everything but the preferences. */
export function clearSignedInStorage(storage: Storage): void {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key !== null && !key.startsWith(PREFIX)) keys.push(key);
  }
  keys.forEach(key => storage.removeItem(key));
}
